export default {
    withPix: 'Pagamento com PIX',
    tryAgain: 'Tentar novamente',
    readQrCode: 'Escanear o QR Code',
    loadQrCode: 'Gerando seu QR Code',
    subscribe: 'Assinar via PIX sem promoção',
    myShopping: '<a href="/assinatura">"minhas compras"</a>',
    hoursInformative: 'Você tem 24h para completar o pagamento',
    assinet: 'A cobrança aparecerá em nome de <strong>ORBE VENTURES</strong>',
    error: 'Tivemos um problema ao gerar o código da sua transação, por favor tente novamente ou retorne mais tarde',
    purchaseInformative: 'Após realizar o pagamento, sua assinatura pode levar alguns minutos para ser processada. Você pode conferir o status de sua compra em',
    purchaseInformativeOTS: 'Após realizar o pagamento, sua compra pode levar alguns minutos para ser processada. Você pode conferir o status de sua compra em',

    instrucions: {
        first: 'Acesse o APP ou o Internet Banking do seu banco',
        second: 'Acesse o menu PIX',
        third: 'Copie o código no Pix Copia e Cola',
        thirdDesk: 'Copie o código no Pix Copia e Cola, <strong>ou</strong> abra o leitor de QR Code',
    },

    button: {
        copy: 'Copiar Código',
        copied: 'Código copiado!'
    },

    coupon: {
        label: 'Cupom de desconto'
    },

    cpf: {
        label: 'CPF do pagador',
        placeholder: '000.000.000-00',
        informative: 'Seu CPF é utilizado apenas para identificar e confirmar o pagamento. Seus dados são protegidos e não serão compartilhados com terceiros.',
        submit: 'Gerar código PIX',
        error: 'CPF inválido'
    }
};